import Header from "../components/Header"
import Banner from "../components/Banner"
import SobreEvento from "../components/SobreEvento"
import Local from "../components/Local"
import CommercialEdition from "../components/CommercialEdition"
import Footer from "../components/Footer"
import NossosConvidados from "../components/NossosConvidados"
import QrCode from "../components/QrCode"

const Views = () => {
    return (
        <>
            <Header />
            <Banner />
            <SobreEvento />
            <NossosConvidados />
            <CommercialEdition />
            <QrCode />
            <Local />
            <Footer />
        </>
    )
}

export default Views